import React from 'react'

const AmazonIcon = () => {
  return (
    <svg
    width={20}
    height={17}
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    >
    <path
        d="M17.3181 13.7361C17.3182 13.736 17.3181 13.7359 17.318 13.7359C8.92058 17.3621 3.70875 14.3282 0.372035 12.4853C0.165961 12.3695 -0.185318 12.5125 0.119026 12.83C1.2308 14.0525 4.87339 16.9999 9.62775 16.9999C14.3821 16.9999 17.2158 14.6444 17.57 14.2337C17.9211 13.8261 17.6736 13.6017 17.3182 13.7363C17.3181 13.7363 17.318 13.7362 17.3181 13.7361ZM19.677 12.5546C19.677 12.5544 19.6769 12.5542 19.6767 12.554C19.451 12.288 18.3053 12.2382 17.5847 12.3189C16.8623 12.3966 15.7784 12.797 15.8723 13.0376C15.9207 13.1278 16.0197 13.0874 16.5155 13.0471C17.0127 13.0024 18.4068 12.8425 18.6972 13.1872C18.9891 13.534 18.2528 15.1863 18.1186 15.4525C17.9888 15.7187 18.1684 15.7877 18.4119 15.6102C18.6525 15.4327 19.0881 14.9736 19.3807 14.3231C19.671 13.67 19.8477 12.7582 19.6772 12.5553C19.677 12.5551 19.677 12.5549 19.677 12.5546Z"
        fill="#F7971D"
    />
    <path
        d="M14.5456 9.47206V3.39985C14.5456 2.35701 13.5365 0 9.91001 0C7.21274 0 5.45507 1.2536 4.73142 2.73576C4.32666 3.56479 5.05971 4.37007 5.9786 4.45235C6.8029 4.52616 7.5466 3.98946 8.07667 3.35389C8.43825 2.92034 8.94937 2.53815 9.62767 2.53815C11.1949 2.53815 11.0871 3.8076 11.0871 4.08187C11.0871 4.81757 10.5033 5.4133 9.77316 5.50341C7.45961 5.78894 4.09595 6.79211 4.09595 10.2443C4.09595 14.5754 9.33635 14.9299 11.4184 12.3802C11.544 12.2264 11.7912 12.2316 11.9282 12.3754C12.3455 12.814 12.8464 13.3031 13.1771 13.6207C13.3751 13.8113 13.689 13.8084 13.8848 13.6155L15.496 12.0234C15.694 11.8276 15.6984 11.5071 15.5026 11.3091C15.1095 10.9102 14.5456 10.2105 14.5456 9.47206ZM7.61387 9.68546C7.61387 8.44533 8.46269 7.83673 9.43929 7.54684C10.3151 7.28687 11.0878 8.06129 11.0878 8.97484C11.0878 12.2845 7.61387 11.7836 7.61387 9.68473V9.68546Z"
        fill="#212529"
    />
    </svg>

  )
}

export default AmazonIcon